module.exports = __webpack_public_path__ + "img/Referenzen_Security1.2a35c4cc.jpg";